Foundation.addToJquery($)
// $(document).foundation()